const th = {
	'快跟我一起来<br />SuperChinese学中文吧!': 'มาเรียนภาษาจีนกับ<br />Super Chinese ไปด้วยกันนะ !',
	'零基础任性学': 'เริ่มเรียนตั้งแต่พื้นฐาน',
	'听说读写全面提升': 'พัฒนาทุกทักษะทั้งฟัง พูด อ่านและเขียน',
	'趣味对话': 'บทสนทนาสนุกสนาน',
	'100+日常对话等你来': 'บทสนทนาในชีวิตประจำวันมากกว่า 100+ ให้คุณได้เรียน',
	'智能AI': 'เทคโนโลยี AI',
	'个性化学习推荐，由浅入深系统学': 'แนะนำการเรียนเฉพาะบุคคล ตั้งแต่เริ่มจนถึงระดับสูง',
	'趣味对话等你来': 'บทสนทนาสนุกๆ รอคุณอยู่',
	'立即打开': 'เปิด',
	'我在SuperChinese<br />已累计学习{day}天': 'Super Chinese ของฉัน<br />เรียนสะสม <span>{day}</span> วัน',
	'我在SuperChinese<br />已连续学习{day}天': 'Super Chinese ของฉัน<br />เรียนต่อเนื่องแล้ว <span>{day}</span> วัน',
	'学习生词': 'เรียนคำศัพท์',
	'学习语法': 'เรียนไวยากรณ์',
	'口语练习': 'แบบฝึกหัดการพูด',
	'{n}个': '<span>{n}</span>',
	'{n}次': '<span>{n}</span>ครั้ง',
	'点击右上角的按钮,选择在浏览器中打开': 'คลิกปุ่มมุมบนขวา,โปรดเลือกเปิดเบราว์เซอร',
	'邀请码': 'โค้ดเชิญเพื่อน',
	'用邀请码注册，参与抽大奖': 'เชิญผู้ใช้งานใหม่และกรอกโค้ดเชิญเพื่อนเพื่อเข้าร่วมการจับรางวัล',
}
export default th;